import BestPracticePage from "./BestPracticePage"

export default BestPracticePage
